<template>
<div class="chapter">
<div class="inner_page">
<h2 class="prect"><a id="pxii"></a><a href="#/Contents.htm#ch0d">Author’s Note</a></h2>
<p class="ftxt">Many languages were spoken along the Thailand–Burma Railway including English, Dutch and Japanese. As a result place names often have a variety of spellings, indicating a foreigner’s attempt to pronounce a Thai word phonetically.</p>
<p class="txt">In most instances I have adopted the form commonly used by historians of the railway, for example, Ban Pong, Chungkai, Hintok, Nakhon Pathom, Nong Pladuk, Tarsao, Wampo.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Authors_Note.vue?8ff6d968